import gql from "graphql-tag";

export default gql`
  query {
    getPageBuilders {
      id
      img_desktop
      img_mobile
      blocks
      detail {
        id
        title
        slug
        meta_title
        meta_description
        meta_tags
        meta_og_title
        meta_og_description
        meta_og_url
        language_code
      }
      created_at
      updated_at
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/page-builder/getAll.js